module.exports = __webpack_public_path__ + "img/zizhujiezhang@2x.56f98dc3.png";